module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log"
  }, [(_vm.isLoading) ? _c('Spinner', {
    staticStyle: {
      "padding-bottom": "50px"
    },
    attrs: {
      "color": "blue"
    }
  }) : _c('div', {
    staticClass: "log-list"
  }, [(_vm.sortedActivities.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].there_is_no_logged_activity))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.packedActivities), function(activity) {
    return _c('li', {
      key: activity.at,
      staticClass: "activity"
    }, [_c('div', {
      staticClass: "activity__headline"
    }, [(_vm.usersHash[activity.by.id]) ? _c('div', {
      staticClass: "user"
    }, [_c('img', {
      attrs: {
        "src": _vm.getUserImg(activity)
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getUserName(activity)))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "activity__headline__timestamp hint--top-left",
      attrs: {
        "aria-label": _vm.formatDate(activity.at)
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getDuration(activity.at)) + " " + _vm._s(_vm.i18n[_vm.locale].ago) + "\n          ")])]), _vm._v(" "), _c('ul', {
      staticClass: "activity-changes"
    }, _vm._l((activity.changes), function(change) {
      return _c('li', {
        key: change.at,
        staticClass: "activity-changes__change"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.humanizeChange(change))
        }
      })])
    }), 0)])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69107416!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormLog.vue
// module id = 1694
// module chunks = 1